import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";

export function RoomJoinError({ code, onRetry }: { code: string; onRetry: () => void }) {
  const { t } = useTranslation();
  const title =
    code === "server-full"
      ? "home.serverFull"
      : code === "room-full"
        ? "home.full"
        : "home.unavailable";
  return (
    <>
      <h1 className="my-6 font-heading text-4xl leading-tight font-normal tracking-tighter">
        {t(title)}
      </h1>
      <p role="alert" className="my-3.5 text-sm leading-loose text-muted-foreground">
        {code === "room-full"
          ? t("home.fullBody")
          : t(`home.errors.${code}`, { defaultValue: t("home.errors.default") })}
      </p>
      <Button onClick={onRetry}>{t("home.retry")}</Button>
    </>
  );
}
